module.exports = __webpack_public_path__ + "img/kujira-small.33442a7f.svg";